import React from 'react';
import { observer } from 'mobx-react';
import i_ from 'i18next';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import { withTheme } from '@material-ui/core/styles';

class EditDialog extends React.Component {
  constructor(props) {
    super(props);
    this.styles = {
      titleStyle: {
        background: this.props.theme.palette.primary.main,
        color: this.props.theme.palette.primary.contrastText,
      },
      bodyStyle: {
        padding: 0,
        overflowY: 'auto',
        height: '450px',
        maxHeight: '450px',
      },
      contentStyle: {
        width: '80%',
        maxWidth: '1000px',
      },
      actionLeft: {
        marginRight: 'auto',
      },
      inputStyle: {
        display: 'none',
        width: '100%',
      },
    };
  }

  handleUpload = e => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    reader.onloadend = () => {
      this.props.onAttached(reader.result);
      var data = new FormData();
      data.append('file', file);
      fetch(process.env.REACT_APP_API_URL + '/suporte/chamada/37/anexar', {
        method: 'POST',
        credentials: 'include',
        body: data,
      }).then(response => console.log(response));
    };
    reader.readAsText(file);
  };

  actions = (onSave, onCancel, onConclude, onAttached) => {
    let actions = [];
    if (onConclude) {
      actions.push(
        <div style={this.styles.actionLeft} key="concluded">
          <Button onClick={onConclude}>{i_.t('dialogs.conclude')}</Button>
        </div>
      );
    } else if (onAttached) {
      actions.push(
        <div style={this.styles.actionLeft} key="attached">
          <Button containerElement="label">
            {i_.t('dialogs.attach')}
            <input
              onChange={this.handleUpload}
              style={this.styles.inputStyle}
              type="file"
            />
          </Button>
        </div>
      );
    }
    actions.push(
      <Button color="primary" onClick={onSave} key="save">
        {i_.t('dialogs.save')}
      </Button>
    );
    actions.push(
      <Button onClick={onCancel} key="cancel">
        {i_.t('dialogs.cancel')}
      </Button>
    );
    return actions;
  };

  render() {
    const {
      children,
      opened,
      onSave,
      onCancel,
      title,
      onConclude,
      onAttached,
    } = this.props;
    return (
      <Dialog maxWidth="md" fullWidth={true} open={opened}>
        <DialogTitle style={this.styles.titleStyle} disableTypography={true}>
          <Typography style={this.styles.titleStyle} variant="title">
            {title}
          </Typography>
        </DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions style={this.styles.actionsContainerStyle}>
          {this.actions(onSave, onCancel, onConclude, onAttached)}
        </DialogActions>
      </Dialog>
    );
  }
}

EditDialog.propTypes = {
  children: PropTypes.node,
  opened: PropTypes.bool,
  onCancel: PropTypes.func,
  title: PropTypes.node.isRequired,
  historyModel: PropTypes.string,
  historyId: PropTypes.number,
  onConclude: PropTypes.func,
  onAttached: PropTypes.func,
};

export default withTheme()(observer(EditDialog));



// WEBPACK FOOTER //
// ./src/components/commons/EditDialog.js